import gql from 'graphql-tag';

export default gql`
mutation insertPublicationLogs($objects: [publication_logs_insert_input!]!) {
  insert_publication_logs(objects: $objects) {
    affected_rows
  }
}
`;
